export enum OrderNoteType {
    RESTAURANT = 'Restaurant',
    DELIVERY = 'Delivery'
  }
  